const elements = document.querySelectorAll<HTMLElement>('[data-focus-overlay]')

elements.forEach((element) => {
	element.addEventListener('focusin', () => document.body.classList.add(...element.dataset.focusOverlay!.split(' ')))
	element.addEventListener('blur', () => document.body.classList.remove(...element.dataset.focusOverlay!.split(' ')))
})
